import React from 'react';

export const PeopleGroup = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.126 9.99977H4C2.887 9.99977 2 10.8948 2 11.9998V15.7298C2 17.0398 3.874 17.7828 6 17.9598V14.9958C6.00159 14.201 6.3183 13.4392 6.88068 12.8776C7.44306 12.316 8.2052 12.0003 9 11.9998H9.354C8.7539 11.4709 8.32615 10.7742 8.126 9.99977ZM15.874 9.99977H20C21.105 9.99977 22 10.8848 22 11.9998V15.7298C22 17.0398 20.126 17.7828 18 17.9598V14.9958C17.9989 14.2008 17.6824 13.4388 17.1199 12.877C16.5574 12.3153 15.795 11.9998 15 11.9998H14.646C15.2461 11.4709 15.6738 10.7742 15.874 9.99977ZM9.967 5.55377C9.87498 4.94282 9.59657 4.37518 9.16981 3.92841C8.74304 3.48164 8.18875 3.17753 7.58265 3.05763C6.97656 2.93772 6.34823 3.00788 5.7835 3.25851C5.21878 3.50914 4.74521 3.92802 4.4275 4.45791C4.10979 4.98781 3.96343 5.60287 4.00843 6.21908C4.05342 6.83528 4.28758 7.42256 4.67889 7.90068C5.07021 8.3788 5.59961 8.72444 6.19475 8.89037C6.78989 9.05631 7.42175 9.03444 8.004 8.82777C8.03235 8.16166 8.22679 7.51322 8.56962 6.94142C8.91246 6.36961 9.39282 5.8926 9.967 5.55377ZM15.997 8.82777C16.5792 9.03435 17.2109 9.05618 17.806 8.89026C18.401 8.72435 18.9304 8.37878 19.3217 7.90077C19.713 7.42276 19.9471 6.8356 19.9922 6.2195C20.0373 5.6034 19.8911 4.9884 19.5736 4.45851C19.2561 3.92861 18.7828 3.50965 18.2182 3.25885C17.6537 3.00805 17.0255 2.93765 16.4194 3.05726C15.8133 3.17687 15.259 3.48065 14.832 3.92712C14.4051 4.37359 14.1264 4.94097 14.034 5.55177C14.6088 5.89044 15.0895 6.36768 15.4324 6.93993C15.7753 7.51219 15.9694 8.16121 15.997 8.82777Z"
      fill={color || '#B3BAC5'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14.9998C7 13.8948 7.887 12.9998 9 12.9998H15C16.105 12.9998 17 13.8848 17 14.9998V18.7298C17 21.7568 7 21.7568 7 18.7298V14.9998Z"
      fill={color || '#B3BAC5'}
    />
    <path
      d="M12 11.9998C13.6569 11.9998 15 10.6566 15 8.99977C15 7.34291 13.6569 5.99977 12 5.99977C10.3431 5.99977 9 7.34291 9 8.99977C9 10.6566 10.3431 11.9998 12 11.9998Z"
      fill={color || '#B3BAC5'}
    />
  </svg>
);
